


































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop } from "vue-property-decorator";

import MapUI from "@/components/map/MapUI.vue";
import ControlsUI from "@/components/map/ControlsUI.vue";
import ScaleCoordinateUI from "@/components/map/ScaleCoordinateUI.vue";
import LegendUI from "@/components/map/LegendUI.vue";
import TreeListUI from "@/components/shared/TreeListUI.vue";
import WindowUI from "@/components/shared/WindowUI.vue";
import DialogUI from "@/components/shared/DialogUI.vue";
import UploadUI from "@/components/shared/UploadFileUI.vue";
import EcoPlantBase from "./ecoplant.base";

import { getPresentPeriod } from "./data/ecoplant";

import Map from "@/components/map/Map";
import { IMapViewInfo, Extent } from "@/components/map/types";
import { IUploadFile, IIconMenu, EUserGroup } from "@/components/shared/types";
import { User } from "@/components/User";

export const CROPS = [
    'cropRice','cropMaize','cropSugarCane','cropCassava'
  ];
const HELP_MENU:IIconMenu = {
  title: 'help',
  icon: 'picture_as_pdf',
  url: '/static/docs/EcoPlant_User_Manual.pdf'
}
const UPLOAD_MENU:IIconMenu = {
  title: 'upload',
  icon: 'cloud_upload'
}

@Component({
  components: {
    'ol-map': MapUI,
    'ol-controls': ControlsUI,
    'ol-scale-coordinate': ScaleCoordinateUI,
    'v-legend': LegendUI,
    'v-tree-list': TreeListUI,
    'v-window': WindowUI,
    'v-dialog': DialogUI,
    'file-upload': UploadUI
  }
})
export default class EcoPlant extends EcoPlantBase {
  PresentPeriod: string = '';
  AdminTabs: string = "USERS";
  
  menuHelp: IIconMenu = HELP_MENU;
  menuUpload: IIconMenu = UPLOAD_MENU;
  uploadCrops = CROPS;
  uploadActiveCrop: string = CROPS[0];
  uploadActiveDataset: "shape" | "map" | "report" | "rid" | "disaster" = "shape";

  // lifecycle methods
  created() {
    window.addEventListener('beforeunload', this.clearOpener);
    this.activeBaseMap = 'osm.cycle';
    if (this.ImAdmin) {
      this.language = 'th';
    }
    this.PresentPeriod = getPresentPeriod(); // for upload ecoplant data
    this.fetchProvinces();
    this.fetchRidAreas();
    this.fetchPageView('ecoplant');
  };

  mounted() {
    this.DrawerHeight = window.innerHeight - 76;
    this.clockInterval = setInterval(() => {
      let d = new Date();
      let hh = ('0' + d.getHours()).slice(-2);
      let mm = ('0' + d.getMinutes()).slice(-2);
      let ss = ('0' + d.getSeconds()).slice(-2);
      let yy = d.getFullYear() + 543;
      let MM = ('0' + (d.getMonth() + 1)).slice(-2);
      let dd = ('0' + d.getDate()).slice(-2); 
      this.timeNow = dd + '-' + MM + '-' + yy + ' ' + hh + ':' + mm + ':' + ss;
    }, 1000);
    if (this.ForAdmin) {
      this.doMenuAction(this.menuUpload);
    } else {
      this.showDrawerLeft = true;
      this.showDrawerLeftLast = this.showDrawerLeft;
    }
  };

  beforeDestroy() {
    clearInterval(this.clockInterval);
    if (this.ForAdmin) {
      this.$store.commit('notifyChange', {
        ForAdmin: false
      });
    }
  };

  get UploadDatasetTitle() : string {
    return this.uploadActiveDataset=='shape' ? 'downloadShapeFile' :
           this.uploadActiveDataset=='map' ? 'downloadMapFile' :
           this.uploadActiveDataset=='report' ? 'downloadReportFile' :
           this.uploadActiveDataset=='rid' ? 'downloadRIDFile' : 'downloadRiceDisaster';
  };

  get ForAdmin() : boolean {
    return this.$store.getters.ForAdmin;
  };

  get crop() : string[] {
    return [this.uploadActiveCrop];
  };
  
  async onMapCreated(map:Map) {
    // map is a full component from olMap, including the native olMap
    // BaseMaps, active action, ... and all methods to call
    this.$map = map; // the same as this.$refs.map
    await this.getMapLayerStore();
    this.$map.createOverlayLayersAndControls(this.mapLayersReversed);
    this.mapLayers = this.mapLayersOrdered;
  };

  onOpenBasemap(open:boolean) {
    this.BaseMapListIsOpen = open;
  }

  /**
   * viewInfo: IMapViewInfo
   */
  onViewChange(viewInfo: IMapViewInfo) {
  };
  
  doMenuAction(menu:IIconMenu) {
    this.DrawerHelperTitle = menu.title;
    if (menu.icon) {
      this.DrawerHelperIcon = menu.icon;
      this.DrawerHelperAvatar = null;
    } else {
      this.DrawerHelperIcon = null;
      this.DrawerHelperAvatar = this.User.Avatar;
    }
    this.showDrawerLeftLast = this.showDrawerLeft;
    this.showDrawerLeft = false;
    this.showDrawerRight = false;
    setTimeout(() => {
      this.showDrawerRight2 = true;
      this.doHelperTool(menu);
    }, 0); // give time to close the right most sidedrawer
  };

  doHelperTool(menu:IIconMenu) {
    switch (menu.title) {
    case 'help':
      this.DrawerHelperFile = menu.url;
      this.DrawerHelperPage = 'help';
      this.DrawerHelperSubTitle = '';
      break;
    case 'upload':
      this.DrawerHelperPage = 'upload';
      this.DrawerHelperSubTitle = '';
      break;
    }
  };

  // toc for search or land info
  toggleToc(toc) {
    switch (toc) {
      case 'RICE':
      case 'MAIZE':
      case 'SUGARCANE':
      case 'CASSAVA':
        if (toc != this.topic) {
          this.topic = toc;
          if (this.toc=='DOWNLOAD') {
            this.getDownloadLists();
          } else {
            this.toc = 'LAYERS';
          }
          this.changeCropLayer();
        }
        break;
      case 'DOWNLOAD':
        if (this.toc=='DOWNLOAD') {
            this.changeCropLayer();
            this.toc = 'LAYERS';
          } else {
            this.getDownloadLists();
            this.toc = toc;
          }
        break;
      default:
        this.toc = toc;
        break;
    }
    /*
    if (toc != this.toc) {
      this.toc = toc;
      if (this.toc=='DOWNLOAD') {
        this.getDownloadLists();
      }
      //this.topic = null; // dont remove it, we need to keep the topic
    }*/
    this.showDrawerLeft = true;
  };

  shapeFiles:IUploadFile[] = [];
  mapFiles:IUploadFile[] = [];
  reportFiles:IUploadFile[] = [];
  ridFiles:IUploadFile[] = [];
  disasterFiles:IUploadFile[] = [];

  uploadShapeFiles:boolean = false;
  uploadMapFiles:boolean = false;
  uploadReportFiles:boolean = false;
  uploadRIDFiles:boolean = false;
  uploadDisasterFiles:boolean = false;

  doUploadFile() {
    switch (this.uploadActiveDataset) {
    case 'shape':
      this.uploadShapeFiles = true;
      //(<any>this.$refs['shape']).startUpload();
      break;
    case 'map':
      this.uploadMapFiles = true;
      break;
    case 'report':
      this.uploadReportFiles = true;
      break;
    case 'rid':
      this.uploadRIDFiles = true;
      break;
    case 'disaster':
      this.uploadDisasterFiles = true;
      break;
    }
   };

   cancelUploadFile() {
    switch (this.uploadActiveDataset) {
    case 'shape':
      this.uploadShapeFiles = false;
      break;
    case 'map':
      this.uploadMapFiles = false;
      break;
    case 'report':
      this.uploadReportFiles = false;
      break;
    case 'rid':
      this.uploadRIDFiles = false;
      break;
    case 'disaster':
      this.uploadDisasterFiles = false;
      break;
    }
   };

  addShapeFiles(files:IUploadFile[]) {
    files.forEach((file) => {
      this.shapeFiles.push(file);
    });
  };

  removeShapeFile(file:IUploadFile) {
    this.shapeFiles.forEach((f,i) => {
      if (f==file)
      this.shapeFiles.splice(i,1);
    });
    this.shapeFiles.forEach((f,i) => {
      f.index = i + 1;
    });
  };

  addMapFiles(files:IUploadFile[]) {
    files.forEach((file) => {
      this.mapFiles.push(file);
    });
  };

  removeMapFile(file:IUploadFile) {
    this.mapFiles.forEach((f,i) => {
      if (f==file)
      this.mapFiles.splice(i,1);
    });
    this.mapFiles.forEach((f,i) => {
      f.index = i + 1;
    });
  };

  addReportFiles(files:IUploadFile[]) {
    files.forEach((file) => {
      this.reportFiles.push(file);
    });
  };

  removeReportFile(file:IUploadFile) {
    this.reportFiles.forEach((f,i) => {
      if (f==file)
      this.reportFiles.splice(i,1);
    });
    this.reportFiles.forEach((f,i) => {
      f.index = i + 1;
    });
  };

  addRIDFiles(files:IUploadFile[]) {
    files.forEach((file) => {
      this.ridFiles.push(file);
    });
  };

  removeRIDFile(file:IUploadFile) {
    this.ridFiles.forEach((f,i) => {
      if (f==file)
      this.ridFiles.splice(i,1);
    });
    this.ridFiles.forEach((f,i) => {
      f.index = i + 1;
    });
  };

  addDisasterFiles(files:IUploadFile[]) {
    files.forEach((file) => {
      this.disasterFiles.push(file);
    });
  };

  removeDisasterFile(file:IUploadFile) {
    this.disasterFiles.forEach((f,i) => {
      if (f==file)
      this.disasterFiles.splice(i,1);
    });
    this.disasterFiles.forEach((f,i) => {
      f.index = i + 1;
    });
  };
}
